module.exports = __webpack_public_path__ + "static/media/footer-logo.9f7877cb.png";